import { Namespace } from "@cirrus/fe-lib"

import { shared } from "../_params.js"

export const CoreConfig = {
  domain: Namespace.domain(shared, "Config"),
}
